export enum InventoryWarningMessageColor {
  Green = 'green',
  Red = 'red',
  Yellow = 'yellow',
}
